<template>
  <base-table
    title="Vessels"
    item-title="Vessel"
    route-name="vesselDetails"
    :headers="headers"
    :url="url"
    :item="vessel"
    :item-id="vessel.vesselId"
    @set-item="setItem"
  >
    <v-text-field
      v-model="vessel.name"
      :rules="[rules.required]"
      label="Vessel Name"
      required
    ></v-text-field>
    <v-text-field
      v-model="vessel.systemType"
      :rules="[rules.required]"
      label="System Type"
      required
    ></v-text-field>
  </base-table>
</template>

<script>
import ObjectType from '@/services/Objects.js'
import BaseTable from '@/components/tables/BaseTable.vue'
import Validation from '@/mixins/validation.js'

export default {
  name: 'VesselTable',
  components: {
    BaseTable
  },
  mixins: [Validation],
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'action', width: '100px' }
      ],
      vessel: {
        name: '',
        systemType: ''
      },
      url: ObjectType.Vessel
    }
  },
  methods: {
    setItem(item) {
      this.vessel = Object.assign({}, item)
    }
  }
}
</script>

<style scoped></style>
